/* eslint-disable camelcase */
import en_AU from './locale/en_AU';
import en_GB from './locale/en_GB';
import en_US from './locale/en_US';
import fr_CA from './locale/fr_CA';
import it_IT from './locale/it_IT';
import ja_JP from './locale/ja_JP';

export default {
	en_AU,
	en_GB,
	en_US,
	fr_CA,
	it_IT,
	ja_JP
};
